import { HeartFilled } from '@fcc/icons';
import { Overlapping } from '@ui/likes/styles';
import tokens from '@fcc/tokens/dist/tokens.json';
import { LikesProps } from './types';

export const Likes = ({ color = '774098', count = 1, isActive }: LikesProps): JSX.Element => {
    const icons = [];

    for (let i = 1; i <= count; i++) {
        icons.push(
            <Overlapping color={color} count={i} key={i} isActive={isActive}>
                <HeartFilled color={tokens.color.primary.brand.white} />
                <HeartFilled />
            </Overlapping>
        );
    }

    return <div>{icons}</div>;
};
